/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export type PreloadPageAssetsCallback = (path?: string) => void;

// istanbul ignore next
export const PageRouteAssetPreloadContext = createContext<PreloadPageAssetsCallback>(() => {});
